import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import { FullTile } from 'views/slides/activities/matching_pairs/components'
import Modalizer from 'components/modalizer/modalizer'
import buildGrid from 'helpers/grid_builder'

import styles from './tiles_modal.scss'

class MatchingPairsTilesModal extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			pair_data: null,
			modal_width: 0,
			modal_height: 0,
			font_size: '0px',
		}
	}

	handleResize() {
		const MODALIZER_INTERNAL_HORIZONTAL_PADDING = 27
		const MODALIZER_INTERNAL_VERTICAL_PADDING = 0
		const MODALIZER_BORDER = 1
		const MODALIZER_HORIZONTAL_PADDING = 100
		const MODALIZER_VERTICAL_PADDING = 60
		const GRID_WIDTH = this.container.offsetWidth
			- MODALIZER_HORIZONTAL_PADDING
			- MODALIZER_INTERNAL_HORIZONTAL_PADDING * 2
			- MODALIZER_BORDER * 2
		const GRID_HEIGHT = this.container.clientHeight
			- MODALIZER_VERTICAL_PADDING
			- MODALIZER_INTERNAL_VERTICAL_PADDING
		const TILE_COUNT = this.props.tiles.length
		if (GRID_WIDTH <= 0 || GRID_HEIGHT <= 0 || TILE_COUNT === 0) {
			return
		}
		const TILE_TYPE = this.props.tiles[0].display.type
		// If the content is only one and is text, we need to calculte as 2 tiles, to have a wider view
		const CARD_RATIO = TILE_COUNT === 1 && TILE_TYPE !== 'image' ? 2 : 1
		const results = buildGrid(GRID_WIDTH, GRID_HEIGHT, TILE_COUNT, CARD_RATIO)
		const card_size_data = results[0]
		const modal_width = card_size_data.width * card_size_data.cols
		const modal_height = card_size_data.height * card_size_data.rows + MODALIZER_INTERNAL_VERTICAL_PADDING
		const orientation_width_compensation = modal_width > modal_height ? 7 : -37
		const orientation_height_compensation = modal_width > modal_height ? 0 : 15

		const fontRelativeWidth = card_size_data.width
		// This defines the relative font for all tiles sizes.
		// Original size is 40px when tile is 400px. Hence 40 / 400.
		const font_size = fontRelativeWidth * 40 / 400 + 'px'
		this.setState({
			pair_data: card_size_data,
			modal_width: modal_width
				+ MODALIZER_INTERNAL_HORIZONTAL_PADDING * 2
				+ MODALIZER_BORDER * 2
				+ orientation_width_compensation,
			modal_height: modal_height
				+ 15
				+ orientation_height_compensation,
			font_size,
		})
	}

	componentDidMount() {
		this.handleResize()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.resize !== this.props.resize) {
			this.handleResize()
		}
	}

	render() {
		return (
			<div
				ref={elem => {
					this.container = elem
				}}
				style={{
					width: '100%',
					height: '100%',
					fontSize: this.state.font_size,
					position: 'absolute',
					top: 0,
					left: 0,
				}}
			>
				{this.state.pair_data &&
					<Modalizer
						nopadding
						boxed={false}
						closeAction={this.props.closeHandler}
						width={this.state.modal_width + 'px'}
						height={this.state.modal_height + 'px'}
					>
						{ this.props.tiles.length === 1 &&
							<FullTile
								tile_data={this.state.pair_data}
								content={this.props.tiles[0]}
								onImmersiveReaderTransform={this.props.onImmersiveReaderTransform}
								shouldShowImmersiveReader={this.props.shouldShowImmersiveReader}
							/>
						}
						{ this.props.tiles.length === 2 &&
							<div styleName='wrapper'>
								<FullTile
									borderless
									tile_data={this.state.pair_data}
									content={this.props.tiles[0]}
									onImmersiveReaderTransform={this.props.onImmersiveReaderTransform}
									shouldShowImmersiveReader={this.props.shouldShowImmersiveReader}
								/>
								{ (this.state.modal_width > this.state.modal_height) &&
									<div styleName='line'></div>
									||
									<div styleName='line-v'></div>
								}
								<FullTile
									borderless
									tile_data={this.state.pair_data}
									content={this.props.tiles[1]}
									onImmersiveReaderTransform={this.props.onImmersiveReaderTransform}
									shouldShowImmersiveReader={this.props.shouldShowImmersiveReader}
								/>
							</div>
						}
					</Modalizer>
				}
			</div>
		)
	}
}

MatchingPairsTilesModal.propTypes = {
	tiles: PropTypes.array,
	closeHandler: PropTypes.func,
	resize: PropTypes.number,
	onImmersiveReaderTransform: PropTypes.func,
	shouldShowImmersiveReader: PropTypes.bool,
}

MatchingPairsTilesModal.defaultProps = {
	tiles: [],
	closeHandler: () => {},
	onImmersiveReaderTransform: () => {},
	shouldShowImmersiveReader: false,
}

export default CSSModules(
	MatchingPairsTilesModal,
	styles,
	{ allowMultiple: true }
)
